export const PHONE_NUMBER = '9844639694';
export const PHONE_DISPLAY = '+91 98446 39694';
export const WHATSAPP_NUMBER = '919844639694';
const WHATSAPP_MESSAGE = "Hi Aabha, I'm interested in your workshops";
export const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

// Backward-compatible shape for existing imports.
export const CONTACT = {
  phone: PHONE_NUMBER,
  displayPhone: PHONE_DISPLAY,
  whatsappNumber: WHATSAPP_NUMBER,
  whatsappLink: WHATSAPP_LINK,
} as const;
